import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

let numeral = require('numeral')
numeral.nullFormat('')

export default () => {
  const data = useStaticQuery(query)
  const titre = data.allRsrlComptesXlsxReserve.edges[0].node.TITRE
  return (
    <div className="text-content accordion-content accordion-table">
      <table>
        <tbody>
          <tr>
            <th />
            <th align="right">2025</th>
          </tr>
          {data.allRsrlComptesXlsxReserve.edges.map(({ node }) => (
            <tr key={node.id} className={node.CLASSE}>
              <td>{node.LABEL}</td>
              <td align="right">
                {numeral(node.ANNEE || '')
                  .format('0.00')
                  .toString()
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

const query = graphql`
  query {
    allRsrlComptesXlsxReserve {
      edges {
        node {
          id
          CLASSE
          LABEL
          ANNEE
          ANNEE_PRECEDENTE
          TITRE
        }
      }
    }
  }
`
